import { atom } from 'jotai';

type AutoSaveStatus = '' | 'Saving...' | 'All changes saved' | 'Failed to save';

// Status of auto save
export const autoSaveAtom = atom<AutoSaveStatus>('');

export const startSavingAtom = atom(null, (_get, set) => {
  set(autoSaveAtom, 'Saving...');
});

export const markSavedAtom = atom(null, (_get, set) => {
  set(autoSaveAtom, 'All changes saved');
  setTimeout(() => {
    set(autoSaveAtom, '');
  }, 3000);
});

export const markSaveFailedAtom = atom(null, (_get, set) => {
  set(autoSaveAtom, 'Failed to save');
  setTimeout(() => {
    set(autoSaveAtom, '');
  }, 3000);
});
